import { forwardRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { WHITE, BODY } from '@h2/components/colors'
import { Container } from '@h2/components/layout/container'

const Wrap = styled.div`
  box-sizing: border-box;
  background: ${({ color }) => (color === 'responsive' ? WHITE : color)};
  border-top: ${({ borderTop }) => borderTop};
  border-bottom: ${({ borderBottom }) => borderBottom};

  @media (${features.minWidth.desktop}) {
    background: ${({ color }) => (color === 'responsive' ? BODY : color)};
  }
`
const Panel = forwardRef(function Panel(
  {
    children,
    innerColor,
    color = WHITE,
    borderTop = 'none',
    borderBottom = 'none',
    ...rest
  },
  ref
) {
  return (
    <Wrap
      ref={ref}
      color={color}
      borderTop={borderTop}
      borderBottom={borderBottom}
      {...rest}>
      <Container bgColor={innerColor}>{children}</Container>
    </Wrap>
  )
})

Panel.propTypes = {
  color: PropTypes.string,
  innerColor: PropTypes.string,
  border: PropTypes.string,
  borderTop: PropTypes.string,
  borderBottom: PropTypes.string,
  showNav: PropTypes.Boolean
}

export { Panel }
